<template>
    <div style="height: 400px">
        <div>
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="商品">
                            <el-select v-model="filter.shop_id"
                                       placeholder="请选择商品"
                                       filterable remote
                                       :remote-method="handleSearchShop"
                                       @change="handleChooseShop"
                                       clearable
                                       style="width:200px">
                                <el-option
                                        v-for="item in $parentInfo.dialog_shopCart.shops"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="单价">
                            <el-input v-model="filter.unit_price"
                                      placeholder="单价"
                                      clearable
                                      disabled
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="数量">
                            <el-input v-model="filter.amount"
                                      placeholder="请输入数量"
                                      clearable
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="归还日">
                            <el-input v-model="filter.return_day"
                                      placeholder="请输入归还日"
                                      clearable
                                      disabled
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="免租日">
                            <el-input v-model="filter.free_day"
                                      placeholder="请输入数量"
                                      clearable
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="日租金">
                            <el-input v-model="filter.daily_rent"
                                      placeholder="请输入数量"
                                      clearable
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                总价：{{filter.unit_price*filter.amount|currency('￥',2)}}
            </el-form>
        </div>
        <div>
            <div class="text-right">
                <el-button type="primary" @click="handleSettleShop()">加入</el-button>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Dialog_AddGood",
        data(){
            return{
                filter:{
                    shop_id:'',
                    shop_name:'',
                    amount:1,
                    price:0,
                    return_day:0,
                    free_day:0,
                    daily_rent:0
                },
                shops:[],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetShops()
        },
        destroyed(){

        },
        methods: {
            handleGetShops(){
                this.$wApi.send(this.$parentInfo.path, 'get_shops', {})
            },
            handleSettleShop(){
                this.filter.price=this.filter.unit_price*this.filter.amount
                this.$parentInfo.equipmentLeasing.cartShops.push(JSON.parse(JSON.stringify(this.filter)));
            },
            handleChooseShop(){
                if(this.filter.shop_id){
                    this.filter.unit_price=
                        this.$parentInfo.dialog_shopCart.shops[this.filter.shop_id].price;
                    this.filter.shop_name=
                            this.$parentInfo.dialog_shopCart.shops[this.filter.shop_id].name
                    this.filter.return_day=
                        this.$parentInfo.dialog_shopCart.shops[this.filter.shop_id].return_day
                    this.filter.free_day=
                        this.$parentInfo.dialog_shopCart.shops[this.filter.shop_id].free_day
                    this.filter.daily_rent=
                        this.$parentInfo.dialog_shopCart.shops[this.filter.shop_id].daily_rent
                }
            },
            handleSearchShop(query){
                this.$wApi.send(this.$parentInfo.path, 'search_shops', {'good_name':query})
            }
        }
    }
</script>

<style scoped>

</style>